import { action } from 'typesafe-actions'
import { User } from '@models/user'
import {RequestData} from "@models/axios";

export const enum UsersActionTypes {
    FETCH_REQUEST = '@@users/FETCH_REQUEST',
    FETCH_SUCCESS = '@@users/FETCH_SUCCESS',
    FETCH_ERROR = '@@users/FETCH_ERROR',

    DELETE_REQUEST = '@@users/DELETE_REQUEST',
    DELETE_SUCCESS = '@@users/DELETE_SUCCESS',
    DELETE_ERROR = '@@users/DELETE_ERROR',

    CREATE_REQUEST = '@@users/CREATE_REQUEST',
    CREATE_SUCCESS = '@@users/CREATE_SUCCESS',
    CREATE_ERROR = '@@users/CREATE_ERROR',

    UPDATE_REQUEST = '@@users/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@users/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@users/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = "@@users/FETCH_ITEM_REQUEST",
    FETCH_ITEM_SUCCESS = "@@users/FETCH_ITEM_SUCCESS",
    FETCH_ITEM_ERROR = "@@users/FETCH_ITEM_ERROR",

    FETCH_CURRENT_USER_REQUEST = "@@users/FETCH_CURRENT_USER_REQUEST",
    FETCH_CURRENT_USER_SUCCESS = "@@users/FETCH_CURRENT_USER_SUCCESS",
    FETCH_CURRENT_USER_ERROR = "@@users/FETCH_CURRENT_USER_ERROR",
}



export const fetchRequest = (data:RequestData) => action(UsersActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: User[]) => action(UsersActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(UsersActionTypes.FETCH_ERROR, message);

export const deleteRequest = (data:RequestData) => action(UsersActionTypes.DELETE_REQUEST, data);
export const deleteSuccess = (data:RequestData) => action(UsersActionTypes.DELETE_SUCCESS, data);
export const deleteError = (message: string) => action(UsersActionTypes.DELETE_ERROR, message);

export const createRequest = (data:RequestData) => action(UsersActionTypes.CREATE_REQUEST, data);
export const createSuccess = (data: User[]) => action(UsersActionTypes.CREATE_SUCCESS, data);
export const createError = (message: string) => action(UsersActionTypes.CREATE_ERROR, message);

export const updateRequest = (data:RequestData) => action(UsersActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: User[]) => action(UsersActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(UsersActionTypes.UPDATE_ERROR, message);

export const fetchItemRequest = (data:RequestData) => action(UsersActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: User[]) => action(UsersActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(UsersActionTypes.FETCH_ITEM_ERROR, message);

export const fetchCurrentUserRequest = (data:RequestData) => action(UsersActionTypes.FETCH_CURRENT_USER_REQUEST, data);
export const fetchCurrentUserSuccess = (data: User[]) => action(UsersActionTypes.FETCH_CURRENT_USER_SUCCESS, data);
export const fetchCurrentUserError = (message: string) => action(UsersActionTypes.FETCH_CURRENT_USER_ERROR, message);